import EfishData from './EfishData'
const EfishDataService = {
  datacache: EfishData,
  getData (url, params = null, method = 'get', expires = null) {
    const cache = this.datacache.getData(url, params, method, expires)
    return new Promise(function (resolve) {
      resolve(cache)
    }, function (reject) {
      reject(cache)
    })
  },
  clearAll () {
    this.datacache.clearAll()
  }
}
export default EfishDataService
